module.exports = __webpack_public_path__ + "media/images/placeholder_picture-ed58d6a8119649d2d064e26fc1f0427c.png";